/** @format */

import React from 'react';
import Dropdown from 'src/ui/library/Dropdown';
import Button from 'src/ui/library/Button';
import MenuItem from '@mui/material/MenuItem';
import intl from 'react-intl-universal';
import TextArea from 'src/ui/library/TextArea';

export default function CasesManagerStatusPres(props) {
  const {
    caseStatusId,
    statusList,
    onUpdate,
    handleCaseStatusChange,
    handleOtherReasonChange,
    reasonForStatusChange,
    isError,
    disableUpdate,
    checkSplCharValidation,
    allowedValidationSpecialChars
  }= props;
  return (
    <section className="cases-status cases-manager-status">
      <div className="status-title">{intl.get('cases.status.update')}</div>
      <div className="status-action">
        <Dropdown
          id="caseManagerStatus"
          name="caseManagerStatus"
          label={intl.get('cases.status.caseStatus')}
          onChange={event => handleCaseStatusChange(event.target.value)}
          value={caseStatusId}
          className={'status-action-dropdown'}
          disableUnderline={true}>
          {statusList &&
            statusList.length &&
            statusList.map((item, index) => (
              <MenuItem key={index} value={item.caseManagerCaseStatusId}>
                {item.caseManagerCaseStatus}
              </MenuItem>
            ))}
        </Dropdown>
        <Button disabled={disableUpdate || isError} styleType="secondary" className="status-action-button" onClick={onUpdate}>
          {intl.get('cases.details.buttons.update')}
        </Button>
      </div>
      <div className="status-action status-action-textarea">
        {caseStatusId === 3 && (
          <TextArea
            required={true}
            onChange={event => handleOtherReasonChange(event.target.value)}
            hasError={isError}
            value={reasonForStatusChange}
            label={intl.get('cases.status.reasonForChange')}
            className="notes-area"
            onBlur={e=> checkSplCharValidation(e)}
            errorText={intl.get("questionnaire.errorMessages.splCharErrorText", {
              allowedSpecialChar: allowedValidationSpecialChars.split('').join(" ")})}
          />
        )}
      </div>
    </section>
  );
}
